export default __webpack_public_path__ + "static/modularfrp-8c41c029b2dc3425432aa31588b1ab83.jpg";